<template>
<div class="chapter">
<div class="inner_page">
<a href="https://www.explorethearchive.com/newsletters?utm_source=ARCGOAAAAH&amp;utm_campaign=9781504079488" target="_blank">
<img alt="image" class="svg_cover" src="images/Archive.jpg"/></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// arch.vue?27896036